export const DataUploadType = Object.freeze({
  LeaveData: 1,
  ExtraWorkData: 2,
  CarryForwardData: 3,
  RemoteWorkData: 4
});